import {CLIENT_ID, CLIENT_SECRET, ESSOX_TOKEN_URL, PROXY_URL} from "../Constants";

let apiAccessToken = null;
let refreshInProgress = null;

export const fetchESSOXApiToken = async () => {
    if (!refreshInProgress) {
        refreshInProgress = fetch(PROXY_URL + ESSOX_TOKEN_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Authorization": "Basic " + btoa(CLIENT_ID + ":" + CLIENT_SECRET),
                "X-Requested-With": "XMLHttpRequest"
            },
            body: new URLSearchParams({
                grant_type: "client_credentials",
                scope: "scopeFinit.consumerGoods.eshop"
            })
        })
            .then((res) => res.json())
            .then((data) => {
                apiAccessToken = data.access_token;
                return apiAccessToken;
            })
            .catch((error) => {
                console.error("Token refresh failed", error);
                throw error;
            })
            .finally(() => {
                refreshInProgress = null;
            });
    }
    return refreshInProgress;
};